export default "__VITE_ASSET__DqGTh29Y__"